var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-table',{ref:"haveVote",attrs:{"module-info":_vm.moduleInfoResult,"tb-columns":_vm.tbColumns,"toolbar-btns":_vm.listpageBtnsA,"on-list-data-before-load":_vm.onListDataBeforeLoad,"on-cell-click":_vm.onCellClick}}),_c('dialog-statisics')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }